/*
 *
 * Resources reducer
 *
 */

import { handleActions } from 'redux-actions';
import update from 'immutability-helper';
import {
  processing,
  createList,
  createListResult,
  getListsResult,
  deleteList,
  deleteListSuccess,
  deleteListFail,
  renameList,
  renameListSuccess,
  renameListFail,
} from './actions';

export const initialState = {
  processing: false,
  lists: [],
  listResult: {},
  deleteListResult: {},
  renameListResult: {},
};

const editorListsReducer = handleActions(
  {
    [processing](state, action) {
      return update(state, { processing: { $set: action.payload } });
    },
    [createList](state) {
      return update(state, { listResult: { $set: {} } });
    },
    [createListResult](state, action) {
      return update(state, { listResult: { $set: action.payload } });
    },
    [getListsResult](state, action) {
      return update(state, { lists: { $set: action.payload } });
    },
    [deleteList](state) {
      return update(state, { deleteListResult: { $set: {} } });
    },
    [deleteListSuccess](state, action) {
      return update(state, {
        deleteListResult: {
          $set: action.payload.result,
        },
        lists: { $set: action.payload.newAllLists },
      });
    },
    [deleteListFail](state, action) {
      return update(state, {
        deleteListResult: { $set: action.payload.result },
      });
    },
    [renameList](state) {
      return update(state, { renameListResult: { $set: {} } });
    },
    [renameListSuccess](state, action) {
      return update(state, {
        renameListResult: {
          $set: action.payload.result,
        },
        lists: { $set: action.payload.newAllLists },
      });
    },
    [renameListFail](state, action) {
      return update(state, {
        renameListResult: { $set: action.payload.result },
      });
    },
  },
  initialState,
);

export default editorListsReducer;
